export var TypeActionNursery;
(function (TypeActionNursery) {
    TypeActionNursery["SelectBeforeCultivation"] = "Recipes > SelectBeforeCultivation";
    TypeActionNursery["Cultivate"] = "Recipes > Cultivate";
    TypeActionNursery["CultivateRequest"] = "Recipe > CultivateRequest";
})(TypeActionNursery || (TypeActionNursery = {}));
export var actionRecipeSelectBeforeCultivation = function (recipe) { return ({
    recipe: recipe,
    type: TypeActionNursery.SelectBeforeCultivation,
}); };
export var actionCultivate = function (recipe) { return ({
    recipe: recipe,
    type: TypeActionNursery.Cultivate,
}); };
export var actionCultivateRequest = function (recipe) { return ({
    recipe: recipe,
    type: TypeActionNursery.CultivateRequest,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/nursery/actionNursery.ts
// module id = 351
// module chunks = 3